import React, { useState, useEffect, useCallback } from 'react';
import { useSnackbar } from 'notistack';

import { Grid} from '@material-ui/core';
import ButtonComponent from '@components/Shared/Buttons/Button';
import { Form, Select as SelectAntd,  Input, Spin, Radio } from 'antd';
import { format} from 'date-fns';

import Services, {
  IPerfils,
  IGetAllTipoIntencao,
  IRequestCreateIntencao,
} from './services';

interface IProps {
  idPerfil: number;
}

let nomePessoa: string;


const SolicitacaoIntencao: React.FC<IProps> = ({
    idPerfil,

  }) => {
  const { enqueueSnackbar } = useSnackbar();
  const [formRef] = Form.useForm();
  const [loadingCreateIntencao, setLoadingCreateIntencao] = useState(false);
  const [loadingPerfil, setLoadingPerfil] = useState(false);
  const [loadingPessoa, setLoadingPessoa] = useState(false);

  const [checkCidade, setCheckCidade] =
  useState<any>('');
  const [checkUf, setCheckUf] = useState<any>();
  const [tipoSolicitacaoIntencao, setTipoSolicitacaoIntencao] = useState<number>(63);
  const [tiposInteracao, setTiposInteracao] = useState<IGetAllTipoIntencao[]>([]);
  const [dataFinal, setDataFinal] = useState('dd/mm/aaaa');
  const [dataFinalSelect, setDataFinalSelect] = useState('');
  const [tipoIntencaoSetada, setTipoIntencaoSetada] = useState('DIVERSOS');
  const [tipoIntencaoSelect, setTipoIntencaoSelect] = useState(19);

  async function loadPessoa() {
    setLoadingPessoa(true);

    const services = new Services();
    const { error, response } = await services.GetPessoaByID(idPerfil);

    if (!error && response) {

      nomePessoa = response.nome_pessoa

      setLoadingPessoa(false);
    } else {
      console.log('error', error);
    }
  };


  async function loadPerfil() {
    setLoadingPerfil(true);
    const services = new Services();
    const { error, response } = await services.GetPerfilByID({ id: idPerfil });

    if (!error && response) {
      const perfils: IPerfils = {contato_offline: response.contato_offline,};

      setCheckCidade(perfils.contato_offline.cidade_id)
      setCheckUf(perfils.contato_offline.estado_id)

      formRef.setFieldsValue({
        estado_descricao: response.contato_offline.estado_descricao,
        cidade_id: response.contato_offline.cidade_descricao,
        contato_offline: response.contato_offline,
      });
      setLoadingPerfil(false);
    } else {
      console.log('error', error);
    }
  };

  const loadTiposInteracao = async () => {
    const services = new Services();
    const { error, response } = await services.GetAllTipoIntencao();

    if (!error && response) {
      setTiposInteracao(response);
    }
  };

  async function onSubmit(values: any) {
    setLoadingCreateIntencao(true);
    console.log(values);

    const createIntencao: IRequestCreateIntencao = {
      //horario: values.horario,
     // dia_semana: values.dia_semana,
      descricao: values.descricao,
      nome_completo: nomePessoa,
      data_intencao_inicio: values.data_intencao_inicio,
      data_intencao_fim: dataFinalSelect,
      id_perfil: idPerfil,
      id_cidade: checkCidade,
      id_estado: checkUf,
      id_tipo_solicitacao: tipoSolicitacaoIntencao,
      id_tipo_intencao_missa: tipoIntencaoSelect,
    };

    const service = new Services();
    const { error, response } = await service.CreateIntencao(
      createIntencao,
    );

    //setLoadingCreate(false);

    if (!error) {
      enqueueSnackbar(`Cadastro finalizado com sucesso!`, {
        variant: 'success',
        anchorOrigin: { horizontal: 'right', vertical: 'bottom' },
      });
      setLoadingCreateIntencao(false);
    } else {
      enqueueSnackbar(`Ocorreu um erro`, {
        variant: 'error',
        anchorOrigin: { horizontal: 'right', vertical: 'bottom' },
      });
      setLoadingCreateIntencao(false);
    }
  }

  const clearData = () => {
    formRef.setFieldsValue({
      estado_descricao: '',
      estado_id: '',
      cidade_id: '',
      id_perfil: '',
      nome: '',
      id_tipo_intencao_missa: '',
      data_intencao_inicio: '',
      data_intencao_fim: '',
      descricao: '',
      cpf: '',
    });
  };

  async function loadData(data_intencao_inicio: Date){

    const date = new Date(data_intencao_inicio);
    const futureDate = date.getDate() + 9;
    date.setDate(futureDate);
    const dataFinalFixada = date.toLocaleDateString();
    const formattedDate = format(date, 'yyyy-MM-dd');
    setDataFinal(dataFinalFixada);
    setDataFinalSelect(formattedDate)
  }

  useEffect(() => {
   loadTiposInteracao();
   loadPerfil();
   loadPessoa();
    window.document.title = 'CRM - Intenção';
  }, []);

  return (
    <Grid container>
      <Grid
        container
        item
        justify="center"
        alignItems="center"
        sm={12}
        xs={12}
        style={{ marginTop: 20 }}
      >

        {/* FORMULARIO  */}
        <Grid
            container
            item
            xs={12}
            md={12}
            justify="center"
            alignItems="center"
          >
            <Spin
              size="large"
              spinning={loadingCreateIntencao}
              tip="Enviando dados..."
            >
              <Form
                form={formRef}
                scrollToFirstError={true}
                onFinish={onSubmit}
                requiredMark={false}
                style={{ width: '100%' }}
                layout="vertical"
                initialValues={{
                  estado_descricao: '',
                  cidade_id: '',
                  id_perfil: '',
                  id_tipo_intencao_missa: '',
                  data_intencao_inicio: '',
                  data_intencao_fim: '',
                  descricao: '',
                  cpf: ''
                }}
              >



                  <Grid container item lg={10} sm={10} xs={10} style={{ padding: 10 }}>

                    <Grid
                      item
                      lg={12}
                      xs={12}
                      style={{ paddingRight: 10, paddingLeft: 10 }}
                    >
                      <Form.Item
                        label='Tipo intenção'
                        //name="id_tipo_intencao_missa"
                        //rules={[
                          //{ required: true, message: 'Campo obrigatorio' },
                        //]}
                      >
                        <SelectAntd
                          style={{ width: '100%' }}
                          defaultValue={tipoIntencaoSetada}
                          onChange={value => setTipoIntencaoSelect(Number(value))}
                        >
                          {tiposInteracao.map((option, index) => (
                            <SelectAntd.Option key={option.id} value={option.id}>
                              {option.descricao}
                            </SelectAntd.Option>
                          ))}
                        </SelectAntd>
                      </Form.Item>
                    </Grid>

                    <Grid container>
                      <Grid item lg={6} xs={12} style={{ paddingLeft: 10, paddingRight: 10 }}>
                        <Form.Item name="data_intencao_inicio" label="Data inicial"
                          rules={[
                            {
                              required: true,
                              message: 'Selecione uma data inicio',
                            },
                          ]}
                        >
                          <Input type="date" placeholder="Data de Vencimento"
                          onChange={(e: any) => {

                        loadData(e.target.value);}}
/>
                        </Form.Item>
                      </Grid>

                      <Grid item lg={6} xs={12} style={{ paddingLeft: 10, paddingRight: 10 }}>
                      <Form.Item  label="Data final"

                        >
                          <Input value={dataFinal} disabled />
                      </Form.Item>
                      </Grid>
                    </Grid>

                    <Grid item lg={12} xs={12} style={{ paddingRight: 10, paddingLeft: 10 }}>
                      <Form.Item
                        label='Descrição'
                        name="descricao"
                        rules={[
                          {
                            //required: true,
                            //message: 'Selecione um horário',
                          },
                        ]}
                      >
                       <Input.TextArea />
                      </Form.Item>
                    </Grid>

                    <Grid
                      container
                      justify="center"
                      alignItems="center"
                      item
                      md={12}
                      xs={12}
                    >
                      <Grid item md={5} xs={12} style={{ paddingTop: 10 }}>
                        <ButtonComponent
                          color="default"
                          fullWidth
                          onClick={clearData}
                        >
                          Cancelar
                        </ButtonComponent>
                      </Grid>

                      <Grid item md={1} xs={12} style={{ paddingTop: 10 }}></Grid>

                      <Grid item md={5} xs={12} style={{ paddingTop: 10 }}>
                        <ButtonComponent
                          color="primary"
                          fullWidth
                          type="submit"
                        >
                          Solicitar
                        </ButtonComponent>
                      </Grid>
                    </Grid>
                  </Grid>
              </Form>
            </Spin>
          </Grid>
      </Grid>
    </Grid>
  );
};

export default SolicitacaoIntencao;
